import { AuthProvider } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';
import oidcConfig from 'src/constants/oidcConfig'; 

const AuthSigninProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const navigate = useNavigate();

  return (
    <AuthProvider
      {...oidcConfig}
      onSigninCallback={() => {
        window.history.replaceState({}, document.title, window.location.pathname);
        navigate('/');
      }}
    >
      {children}
    </AuthProvider>
  );
};

export default AuthSigninProvider;